module.exports = __webpack_public_path__ + "media/images/illustrations/sparkle-f1ce0b699dea3116d6aea7208e37566f.svg";